var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "total-price" }, [
    _c("span", {
      staticClass: "total-price__text",
      domProps: { textContent: _vm._s(_vm.translations.header) }
    }),
    _vm._v(" "),
    _c(
      "p",
      { staticClass: "total-price__price" },
      [
        _c("transition", { attrs: { name: "price-transition" } }, [
          _vm.totalPrice
            ? _c("span", { staticClass: "total-price__price__text" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.showFrom ? _vm.translations.from : "") +
                    "\n                "
                ),
                _c("span", {
                  directives: [
                    {
                      name: "price",
                      rawName: "v-price",
                      value: _vm.totalPrice,
                      expression: "totalPrice"
                    }
                  ]
                }),
                _vm._v(
                  "\n                " + _vm._s(_vm.currency) + "\n            "
                )
              ])
            : _vm._e()
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a233cd8e", { render: render, staticRenderFns: staticRenderFns })
  }
}